<div class="apply-shell mx-auto my-4">
    <!-- A trail rather than a single back link, and every step is a real route: someone
         who arrived from a bookmark or a forwarded link has no history to walk, so
         browser back would do nothing or leave the site. Once a permit exists the trail
         is pointless - offering the way back in invites starting again. -->
    @if (showForm) {
        <nav class="apply-shell__crumbs" aria-label="Breadcrumb">
            <a routerLink="/apply">Permit types</a>
            @if (previousRoute) {
                <span class="apply-shell__sep" aria-hidden="true">/</span>
                <a [routerLink]="previousRoute">{{ previousLabel || 'Back a step' }}</a>
            } @else if (previousStep) {
                <span class="apply-shell__sep" aria-hidden="true">/</span>
                <a [routerLink]="['/find', previousStep]">{{ previousLabel || 'Back a step' }}</a>
            }
        </nav>
    } @else {
        <a class="apply-shell__back" [routerLink]="doneLink"> <i class="fa fa-arrow-left me-1" aria-hidden="true"></i>{{ doneLabel }} </a>
    }

    <!-- "Apply for a Tourist Pass" is wrong once they have applied: by then the page is
         a receipt, and the panel below says what happened. -->
    <h1 class="apply-shell__title mt-2">{{ showForm ? 'Apply for a ' + permitLabel : permitLabel }}</h1>

    @if (outcome && showForm) {
        <p class="apply-shell__outcome">{{ outcome }}</p>
    }

    <!-- The card frames a form. A result already carries its own panel, so the card is
         dropped rather than drawing a box around a box. One <ng-content> either way:
         the pages project @if blocks, which a selector-based projection would strand. -->
    <div [class.apply-shell__card]="showForm">
        <ng-content></ng-content>
    </div>
</div>
